import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Marketplace } from 'app/infrastructure/model/classes/marketplace.class';
import {
  MarketplaceService,
  MARKETPLACE_ITEMTYPE_BusinessLogic,
  MARKETPLACE_ITEMTYPE_ChannelReportConfiguration,
  MARKETPLACE_ITEMTYPE_Connections,
  MARKETPLACE_ITEMTYPE_DataLogic,
  MARKETPLACE_ITEMTYPE_NonTransactionalFlow,
  MARKETPLACE_ITEMTYPE_StandardDictionary,
  MARKETPLACE_ITEMTYPE_StandardFlow,
  MARKETPLACE_ITEMTYPE_StandardProductEmail,
  MARKETPLACE_ITEMTYPE_StandardProductReport,
  MARKETPLACE_ITEMTYPE_ViewEngines,
} from 'app/infrastructure/services/marketplace.service';

@Component({
  selector: 'marketplace-dropdown',
  templateUrl: './marketplace-dropdown.component.html',
  styleUrls: ['./marketplace-dropdown.component.scss'],
})
export class MarketplaceDropdown implements OnInit {
  @Input() set marketplaces(marketplaces: Marketplace[]) {
    if (marketplaces) {
      let marketplaceFilteredByType: Marketplace[] = [];
      marketplaces.forEach((marketplace) => {
        if(!marketplaceFilteredByType.map(x => x.type).includes(marketplace.type))
          marketplaceFilteredByType.push(marketplace);
      });
      this._marketplaces = marketplaceFilteredByType;
    }
  }
  get marketplaces(): Marketplace[] {
    return this._marketplaces;
  }

  _marketplaces: Marketplace[];
  categoryTypes: any;
  isCollapsed: boolean = false;
  entities: any[];

  constructor(
    public router: Router,
    protected route: ActivatedRoute,
    public marketplaceService: MarketplaceService
  ) {}

  ngOnInit() {}

  collapseIt() {
    this.isCollapsed = !this.isCollapsed;
  }

  createEntity(model: any) {
    switch (model.type) {
      case MARKETPLACE_ITEMTYPE_StandardFlow:
        this.router.navigate(['../Policy/standardFlows/NewFlow'], {
          relativeTo: this.route.parent,
        });
        break;

      case MARKETPLACE_ITEMTYPE_NonTransactionalFlow:
        this.router.navigate(['../nontransactionalflows'], {
          relativeTo: this.route.parent,
        });
        break;

      case MARKETPLACE_ITEMTYPE_BusinessLogic:
        this.router.navigate(['../businessLogic/New'], {
          relativeTo: this.route.parent,
        });
        break;

      case MARKETPLACE_ITEMTYPE_DataLogic:
        this.router.navigate(['../dataLogic/New'], {
          relativeTo: this.route.parent,
        });
        break;

      case MARKETPLACE_ITEMTYPE_ChannelReportConfiguration:
        this.router.navigate(['../configurationCenter/confReport/nuevo'], {
          relativeTo: this.route.parent,
        });
        break;

      case MARKETPLACE_ITEMTYPE_StandardProductReport:
        this.router.navigate(
          ['../configurationCenter/confProductReport/nuevo'],
          { relativeTo: this.route.parent }
        );
        break;

      case MARKETPLACE_ITEMTYPE_StandardProductEmail:
        this.router.navigate(
          ['../configurationCenter/emails/nuevo'],
          { relativeTo: this.route.parent }
        );
        break;

      case MARKETPLACE_ITEMTYPE_ViewEngines:
        this.router.navigate(['../viewengine/nuevo'], {
          relativeTo: this.route.parent,
        });
        break;

      case MARKETPLACE_ITEMTYPE_Connections:
        break;

      case MARKETPLACE_ITEMTYPE_StandardDictionary:
        this.router.navigate(['../standarddictionary/New'], {
          relativeTo: this.route.parent,
        });
        break;
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/marketplace/marketplace-dropdown/marketplace-dropdown.component.ts